const NewsHomeStyles = () => {
  return (
    <style>
      {`
        .news-article-landing .post-list .featured-image.c1_r1_c1 {
            width: 33%;
        }

        .news-article-landing .post-list .post-content.c1_r1_c2 {
            width: 67%;
        }

        .news-article-landing .post-list .post-content.c1_r1_c2 {
            width: 100%;
        }


        .news-landing {
            margin-top: 40px
        }

            .news-landing .item-list .item .title {
                color: #000;
                font-size: 22px
            }

                .news-landing .item-list .item .title a {
                    color: inherit;
                    font-weight: 700
                }

                .news-landing .item-list .item .title svg {
                    margin-left: 5px;
                    width: 15px;
                    height: 15px
                }

            .news-landing .item-list .item .meta-item.author, .news-landing .item-list .item .meta-item.date {
                font-weight: 300
            }

            .news-landing .item-list .item img {
                max-width: 120px;
                float: right
            }

            .news-landing .news-landing-top-left .item:first-child .title {
                font-size: 29px
            }

            .news-landing .news-landing-right {
                font-size: 15px !important
            }

                .news-landing .news-landing-right h3 {
                    color: #009bc9;
                    margin: 0 0 -20px
                }

                .news-landing .news-landing-right .title {
                    font-size: 15px !important;
                    margin: 0
                }

                .news-landing .news-landing-right .item img {
                    max-width: 60px !important;
                    padding-left: 5px
                }

                .news-landing .news-landing-right .CMSBanner {
                    margin: 0;
                    padding: 1em 0;
                    text-align: center
                }

        @media (min-width:48.063em) {
            .news-landing .news-landing-right .CMSBanner img {
                width: 100%
            }
        }

        @media (min-width:72em) {
            .news-landing .col-sep-bottom:after, .news-landing .col-sep-left:after, .news-landing .col-sep-right:after, .news-landing .col-sep-top:after {
                content: "";
                display: block;
                background-color: #ddd;
                height: 1px;
                width: 1px;
                position: absolute;
                top: 0
            }

            .news-landing .col-sep-left:after, .news-landing .col-sep-right:after {
                height: calc(100% - 40px);
                margin: 20px auto
            }

            .news-landing .col-sep-left:after {
                left: 0
            }

            .news-landing .col-sep-right:after {
                right: 0
            }

            .news-landing .col-sep-bottom:after, .news-landing .col-sep-top:after {
                left: 0;
                width: calc(100% - 40px);
                margin: 0 20px
            }
        }

        .filter-news-search {
	        background-color: #999999;
	        padding: 4px 0px;
        }

        .filter-news-search .form-control {
	        height: 36px;
	        padding: 4px 14px;
        }

        .filter-news-search label {
	        margin-bottom: 5px;
	        font-size: 15px;
        }

        .filter-news-search .btn {
	        margin-top: 0px;
        }

        .filter-news-search legend {
	        font-size: 20px;
        }

        .news-landing div .col_latest_features {
	        padding-left: 3%;
	        padding-right: 1%;
        }

        .sponsoredborder {
	        background-color: #F1F1F1;
	        padding: 6px 12px !important;
        }

        @media (min-width: 768px) {
	        .news-landing div .img-feature {
		        max-width: 100%;
		        padding-left: 2% !important;
	        }
        }

        .news-landing .owl-carousel .owl-dots{
            padding-top:10px;	
        }
        .owl-carousel .owl-nav button.owl-prev, 
        .owl-carousel .owl-nav button.owl-next, 
        .owl-carousel button.owl-dot {
            color: inherit;
            border: none;
            padding: 0 !important;
            font: inherit;
            margin-right: 5px;
            width: 50px;
            background:#E2E7E6;
        }
        .owl-theme .owl-dots .owl-dot.active , 
        .owl-theme .owl-dots .owl-dot:hover {
            background:#FAB84D;
            border-color:#FAB84D;
        }
        .owl-dots {
            width: 100%;
            margin-right: 5px;
            display: flex;
            justify-content: center;
        }
        .owl-carousel.owl-drag .owl-item,.owl-carousel.owl-drag .owl-item .feture-item{
            display: flex;
            justify-content: center;
        }
        .featured-post .featured-content .item-category {
            float: left;
            padding-right: 15px;
        }
        .logo-block .btn.btn-default.btn-responsive{
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right:10px;	
            padding: 5px 15px;
            width: 325px;
                
        }
        .single-grid.summary-latest.sponsoredborder{
            min-height: auto;
            margin-top: 4px;
        }
        .article-block{
            margin-top: 10px;
            width:100%;
        }
        .news-landing{
            margin-top: 20px;
        }
        /* .filter.filter-news-search.fitler-event-search{
        margin-left:15px;
        } */
        .categories.owl-carousel .owl-item img {
            width: 300px;
            height: 250px;
        }
        .logo-block a{
        margin-right:10px;
        }
                
        .logo-block .btn.btn-default.btn-responsive:last-child{
          margin-right:0px;
        }
                
        .sectors a{
            color: #0E8ACB;
        }
                
        .btn-content .btn.btn-default.btn-responsive{
            margin-bottom: 0;
            font-size: inherit;
            color: inherit;
            background-color: #FBC46C;
                   
        }
        .btn-content .btn.btn-default.btn{
            margin-top: 0;
            margin-left: 5px;
        }
        .search-content{
            width: 100%;
            display: flex;
                   
        }
        .featured-content h3{
            font-size: 30px;
        }
        .feature-info ul li a{
            font-weight: 600;
            color: #000000;
            font-size: 14px;
            padding: 5px 0;
        }
        .feature-single img {
            float: left;
            /* width: 300px; */
            height: 250px;
        }
                
        .featured-post{
            padding: 30px 0;
            border-bottom: 1px solid #B3B3B3;
        }
        .post-list{
            /* padding: 10px 0 0 0; */
            padding: 30px 0 0 15px;
        }
        .single-grid{
            display: flex;
            border-bottom: 1px solid #B3B3B3;
            padding-bottom: 10px;
            padding-top: 10px;
            min-height: 295px;
            padding: 10px 5px;
        }
        .feature-section .col-sm-12.d-flex.justify-content-center{
            padding-top: 20px;
        }
        .features-section h2{
            color: #323140;
            margin-bottom: 10px;
            font-weight: 700;
            font-size: 33px;
        }
        .features-section h2, .category-sections h2{
            margin-top:0px;
        }
        .discover-more{
            padding: 10px 0;
            width: 100%;
        }
        .news-landing img.category-img {
            width: 16px;
        }
        .logo-block{
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-top: 20px;
            padding-right: 0px;
        }
        .single-grid.summary-latest.second-article-section:nth-child(odd) {
            padding-right: 15px;
        }
        .single-grid.summary-latest.second-article-section:nth-child(even) {
            padding-left: 15px;
        }
        .filter-news-search{
            background-color:#B5C5D9;
        }
        .news-landing div .img-width{
            padding: 25px 0;
        }
        .newscaption {
          max-width: 300px;
          margin-left: 25px;
        }
        .feature-title{
            color: #FFFFFF;
            padding: 8px 15px;
            font-size: 14px;
            font-weight: 600;
            background: #19204A;
        }
        .category-title{
            color: #FFFFFF;
            padding: 8px 15px;
            font-size: 14px;
            font-weight: 600;
            background: #19204A;
        }
        .featured-content .link-see-more {
            font-size: 14px;
        }
        .news-landing div .img-pin-article{
            max-width: 192px;
            max-height: 160px;
        }
        .discover .sectors {
            padding-bottom: 30px;
        }
        .featured-post .featured-image .img-pin-article{
            width: 300px;
            height: 250px;
        }
          .single-category,.feature-single{
            max-width: 300px;
        } 
        .featured-post .sponsoredborder .featured-image .img-pin-article{
            width: 192px;
            height: 160px;
        }
        .articleteaser img {
            margin-left: 25px;
        }
        .endofarticle {
            font-size: 80%;
        }
                
        @media (min-width: 200px) and (orientation: portrait)
        {
            .news-landing div .img-pin-article {
                /*max-width: 300px;*/
                /*height: 250px;*/
            }
        }
                
        @media only screen and (max-width: 425px)
        {
            .featured-image.c1_r1_c1 {
                display: none;
            }
        }
                
        @media (min-width: 400px) and (orientation: portrait)
        {
            .news-landing div .img-pin-article {
                margin-top: 5px;
                max-width: 300px;
                /*max-height: 90%;*/
                /*height: 250px;*/
                display: block;
                padding-left: 1%;
                padding-bottom: 4%;
                float: left;
                margin-right: 8%;
            }
        }
        @media only screen and (max-width: 767px)
        {
            .post-slider.owl-carousel {
                display: block;
            }
        }
        /* Ketan's css changes END*/
                
                
        .search-block{
            width: 100%;
            padding: 20px 0;
        }
        .search-content form{
            text-align: center;
            display: flex;
            justify-content: space-between;
        }
        .single-grid .category-type .category-text{
        font-size:10px;
        }
        .search-content input.mainfield{
            width: 81%;
            height: 53px;
            padding: 14px 50px 14px 24px;
        }
        .btn-content{
            display: flex;
        }
        .featured-content{
            width: 100%;    
        }
        .post-meta{
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
        .category-tag{
            color: #323140;
            font-size: 14px;    
            font-weight: 600;
        }
        .data-right span{
            font-weight: 400;
            color: #323140;
            font-size: 12px;
            position: relative;
            padding-right: 5px;
        }
                
        .data-right a {    
            font-weight: 500;
            color: #000000;
            font-size: 14px;
            padding-left: 5px;
            text-decoration: underline;
        }
        .data-right a:hover {
            color: #FAAC2E !important;
        }
        .featured-content h3{
            margin: 0 0 5px 0;
        }
        .post-info{
            position: absolute;
            left: 0;
            right: 0;
            margin: 0 auto;
            text-align: center;
            bottom: 5px;
        }
        .post-info span{
                  
            font-weight: 300;
            color: #323140;
            font-size: 14px;
            position: relative;
            padding-right: 8px;
        }
        .post-info span:after{
            position: absolute;
            right: 0;
            top: 4px;
            content: "";
            width: 1px;
            height: 12px;
            background: #000000;
        }
        .post-info a{
                     
            font-weight: 500;
            color: #000000;
            font-size: 14px;
            padding-left: 5px;
            text-decoration: underline;
        }
                
        .featured-image{
            position: relative;
        }
        .post-content{
            padding: 0 0 0 20px;
        }
        .post-content h3{
            margin: 0 0 5px 0;
            -webkit-transition: all 0.3s ease-in-out;
            -moz-transition: all 0.3s ease-in-out;
            -ms-transition: all 0.3s ease-in-out;
            -o-transition: all 0.3s ease-in-out;
            transition: all 0.3s ease-in-out;
        }
        .post-content a:hover,
        .featured-content a:hover,
        .sponsored-content a:hover
        {
            color: #000000;
        }
        .post-content a:hover h3{   
            color: #000000;
        }
        .post-list .featured-image{
            width: 81%;
        }
        .single-grid .post-info{
            right: auto;
            left: 10px;
            bottom: 6px;
        }
        .single-grid .post-info a{
            font-weight: 300;
            font-size: 12px;
            text-decoration: none;
        }
        .single-grid .post-info a:hover{
            color: #FAAC2E;
        }
        .features-section{
            width: 100%;
            padding-bottom: 15px;
        }
        .feature-content{
            width: 100%;
        }
        .feature-single{
            float: left;
            width: 100%;
        }
        .feature-content{
            float: left;
            width: 100%;
            padding: 5px 0 10px 0;
        }
        .feature-content h5{
            margin: 0 0 3px 0;
            line-height: 20px;
            font-size: 18px;
            font-weight: 700;
            color: #000000;
        }
        .feature-info{
            display: flex;
            flex-wrap: wrap;
                     
            font-weight: 300;
            color: #323140;
            font-size: 14px;
        }
        .feature-info span{
                     
            font-weight: 300;
            color: #323140;
            font-size: 14px;
            position: relative;
            padding-right: 8px;
            padding-left: 8px;
        }
        .feature-info span:before{
            position: absolute;
            left: 0;
            top: 4px;
            content: "";
            width: 1px;
            height: 12px;
            background: #000000;
        }
        .feature-info span:first-child:before{
            display: none;
        }
        .feature-info span:first-child{
            padding-left: 0;
        }
        .feature-info ul{
            float: left;
            width: 100%;
            padding: 10px 0 0 0;
            margin: 0;
        }
        .feature-info ul li{
            float: left;
            width: 100%;
            border-bottom: 1px solid #C4C4C4;
            list-style: none;
        }
        .feature-single .view-more{
              display: block;
            font-weight: 600;
            color: #000000;
            font-size: 14px;
        }
        .feature-single.latest-features .feature-content{
            padding: 20px 0 0 0;
            margin-bottom: 3px;
        }
        .feature-single.rf-quaterly .feature-content{
            padding: 20px 0 0 0;
            margin-bottom: 3px;
        }
        .feature-single.for-authors .feature-info ul{
            padding: 0;
        }
        .feature-single.for-authors .feature-info ul li:first-child{
            border-top: 0;
        }
        .feature-single.for-authors .feature-content{
            padding-bottom: 0;
        }
        .category-sections{
            width: 100%;
            margin-top: 10px;
            margin-bottom: 20px;
        }
                
        .category-content{
            float: left;
            width: 100%;
        }
        .category-content ul{
            float: left;
            width: 100%;
            padding: 10px 0 0 0;
            margin: 0;
        }
        .category-content ul li{
            float: left;
            width: 100%;
            border-top: 1px solid #C4C4C4;
            list-style: none;
        }
        .category-content ul li a{
            float: left;
                     
            font-weight: 600;
            color: #000000;
            font-size: 14px;
            padding: 5px 0;
            line-height: 20px;
            text-decoration: none;
        }
        .category-content ul li:first-child{
            border-top: 0;
        }
        .news-list .data-right a{
            text-decoration: none;
        }
        .discover-more h2{
            padding-bottom: 30px;
            margin: 0;
        }
        .feed-single img {
            height: 250px;
            max-width: 300px !important;
            max-height: unset;
        }
                
        .more-list{
            width:100%;
        }
        .more-list ul{
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-bottom: 25px;
            gap: 20px;
            padding: 0;
        }
        .more-list ul li{
            list-style: none;
            margin: 0 0 30px 0;
        }
        .more-list ul li a{
            color: #000000;
            font-size: 16px;
            font-weight: 700;
            padding: 8px 15px 10px;
            border: 1px solid #cccccc;
            text-decoration: none;
        }
        .feed-single{
            float: left;
            width: 100%;
        }
        .feed-content h6{
            margin: 15px 0 10px 0;
        }
        .feed-content ul{
            float: left;
            width: 100%;
            margin: 0;
            padding: 0;
        }
        .feed-content ul li{
            float: left;
            width: 100%;
            list-style: none;
        }
        .feed-content ul li a{
            float: left;
            width: 100%;
            color: #000000;
            font-size: 14px;
            font-weight: 400;
            padding: 8px 15px 10px 0;
            border-top: 1px solid #cccccc;
            text-decoration: none;
        }
        .feed-content ul li:first-child a{
            border: 0;
            padding: 0 15px 10px 0;
        }
        .ad-single{
            float: left;
            width: 100%;
            position: relative;
        }
        .ad-single img {
            width: 100%;
        }
        .ad-content{
            float: left;
            width: 100%;
            position: absolute;
            left: 0;
            bottom:0;
            padding: 0 15px 15px 15px;
        }
        .ad-content h3{
            margin: 0 0 5px 0;
            line-height: 23px;
            font-weight: 600;
            float: left;
            width: 80%;
        }
        .ad-content span{
            float: left;
            width: 100%;
            font-weight: 400;
            font-size: 14px;
            padding-bottom: 7px;
            float: left;
            width: 80%;
        }
        .ad-content .btn.btn-default.btn-responsive{
            margin: 0;
            padding: 5px 24px 4px;
                     
            font-weight: 500;
            width: 100%;
        }
        .ad-block{
            margin-bottom: 40px;
        }
        .quick-links{
            width: 100%;
            background: #E6E6E6;
            padding: 30px 0 20px;
        }
        .quick-links ul{
            padding: 0 100px;
            column-count: 4;
            text-align: center;
        }
        .quick-links ul li{
            list-style: none;
            margin-bottom: 7px;
        }
        .quick-links ul li a{
                     
            font-weight: 600;
            font-size: 14px;
            color: #000000;
            text-decoration: underline;
        }
        .quick-links ul li a:hover{
            color: #FAAC2E;
        }
                
        .single-post .post-meta{
            justify-content: flex-start;
            gap: 25px;
        }
        .single-post{
            margin: 55px 0 40px;
        }
        .single-post h2{
            margin: 10px 0 15px;
            font-size: 20px;
        }
        .single-post img{
            float: right;
            padding: 0 0 5px 20px;
        }
        .detect-mobile{
            display: none;
        }
        .owl-dots {
            display: flex;
          }
        .owl-dot{
            background: #EDF0F0;
            width: 100%;
            height: 10px;
            -webkit-transition: all 0.3s ease-in-out;
            -moz-transition: all 0.3s ease-in-out;
            -ms-transition: all 0.3s ease-in-out;
            -o-transition: all 0.3s ease-in-out;
            transition: all 0.3s ease-in-out;
        }
        .owl-dot.active{
            background: #A7A8A9;
        }
                
        /*Media queries*/
           @media only screen and (min-width: 1024px) and (max-width: 1279px) {
            .logo-block .btn.btn-default.btn-responsive{font-size: 13px;padding: 8px 15px;}
            .logo-block{gap: 10px;}
            .featured-post .col-sm-3{align-self: flex-start;}
            .post-list .post-meta{align-items: flex-start;flex-direction: column;padding: 0 0 7px 0;}
            .single-grid{flex-direction: column;padding-bottom: 10px;margin-bottom: 25px;}
            .post-content{padding: 15px 0 0 0;}
            .post-content h3{line-height: 22px;font-size: 17px;}
            .features-section h2{margin-bottom: 25px;}
            .category-content ul li a{line-height: 18px;font-size: 13px;}
            .ad-content h3{width: 100%;font-size: 16px;line-height: 22px;margin: 0 0 2px 0;}
            .ad-content span{width: 100%;line-height: 18px;}
            .ad-content .btn.btn-default.btn-responsive{font-size: 12px;}
            .quick-links{padding: 24px 0 7px;}
            .quick-links ul{padding: 0;}
            .footer-container{padding: 40px 0 10px;}
            .phone-number{flex-direction: column;}
            .phone-number span{font-size: 14px;padding: 0 8px 0 0;}
            .phone-number span::before {display: none;}
            .footer-menu ul li a{font-size: 15px;}
            .copyright{font-size: 14px;}
            .post-meta{margin-bottom: 6px;}
            p{font-size: 15px;}
            .header-right .menu-li{font-size: 13px;}
            .header-container .btn-responsive{padding: 8px 9px;font-size: 13px;}
            .feature-single img{width:inherit}
            .categories.owl-carousel .owl-item img {width: inherit;}
        }
                
        @media only screen and (min-width: 768px) and (max-width: 991px) {
            .logo-block .btn.btn-default.btn-responsive{font-size: 13px;padding: 30px 15px;height: 45px;white-space: normal;}
            .logo-block{gap: 10px;}
            .featured-post .col-sm-3{align-self: flex-start;}
            .featured-post .featured-image{display: inline-block;width: auto;}
            .post-list .post-meta{align-items: flex-start;flex-direction: column;padding: 0 0 7px 0;}
            .single-grid{flex-direction: row;padding-bottom: 10px;margin-bottom: 25px;}
            .post-content{padding: 15px 0 0 0;}
            .post-content h3{line-height: 22px;font-size: 17px;}
            .features-section h2{margin-bottom: 25px;}
            .category-content ul li a{line-height: 18px;font-size: 13px;}
            .ad-content h3{width: 100%;font-size: 16px;line-height: 22px;margin: 0 0 2px 0;}
            .ad-content span{width: 100%;line-height: 18px;padding-bottom: 10px;}
            .ad-content .btn.btn-default.btn-responsive{font-size: 12px;display: inline-block;}
            .quick-links{padding: 24px 0 7px;}
            .quick-links ul{padding: 0;column-count: 2;}
            .footer-container{padding: 40px 0 10px;}
            .phone-number{flex-direction: column;}
            .phone-number span{font-size: 14px;padding: 0 8px 0 0;}
            .phone-number span::before {display: none;}
            .footer-menu ul li a{font-size: 15px;}
            .copyright{font-size: 14px;text-align: left;}
            .post-meta{margin-bottom: 6px;flex-direction: column;align-items: flex-start;}
            p{font-size: 14px;}
            .featured-content{padding: 15px 0 0;}
            .featured-post{padding: 0 0 10px 0;}
            .post-list .featured-image{width: 100%;margin: 0;}
            .feature-single{margin-bottom: 30px;}
            .features-section{padding-bottom: 5px;}
            .category-sections{margin-top: 25px;}
            .ad-single{margin-bottom: 20px;}
            .ad-block{margin-bottom: 12px;}
            .social-icons{padding-bottom: 10px;}
            .social-icons ul{justify-content: flex-start;}
            .footer-container .col-sm-12.col-md-6.col-lg-3.col-xl-3:nth-of-type(1) { order: 3; }
            .footer-container .col-sm-12.col-md-6.col-lg-3.col-xl-3:nth-of-type(4) { order: 4; }
            .single-post img{float: left;width: 100%;padding: 0 0 20px 0;}
            .categories.owl-carousel .owl-item img {width: inherit;}
            .single-post{margin: 30px 0 10px;}
            .content-footer{margin: 20px 0 20px;}
            .content-footer span{font-size: 14px;}
            .header-right .menu-li{font-size: 12px;padding: 0 5px;}
            .header-container .menu-li.join-li{padding: 0 0 0 5px;}
            .header-container .btn-responsive{padding: 8px 9px;font-size: 12px;}
            .header-right{padding: 0 0 10px 0;}
            .feature-single img{width:inherit}
            .detect-mobile{display: block;}
            .single-grid{width: 100%;}
            .feature-slider .owl-item.active .col-sm-12.col-md-6.col-lg-3.col-xl-3{max-width: 100%;}
            .discover-slider .owl-item.active .col-sm-4{max-width: 100%;}
        }
        @media only screen and (max-width: 767px) {
            .search-content form{flex-direction: column;}
            .search-content{display: block;}
            .search-content input.mainfield{width: 100%;height: 40px;margin-bottom: 20px;}
            /* .btn-content{justify-content: space-between;gap: 20px;display: flex;width: fit-content;} */
            .btn-content{display: inline-flex; text-align: center; padding-left: 22%;}
            .btn-content .btn.btn-default.btn-responsive{margin-left: 0;height: 40px;padding: 5px 0;}
            .logo-block{flex-direction: column;gap: 20px;text-align: center;align-items: center;}
            /* .logo-block .btn.btn-default.btn-responsive{display: none;} */
            .featured-post .featured-image a img{width: 100%;}
            .featured-post .post-info{display: none;}
            .featured-post .featured-image{margin-bottom: 20px;}
            .post-meta{align-items: flex-start;flex-direction: column;margin-bottom: 5px;}
            .featured-content h3{margin: 0 0 10px 0;}
            .quick-links{display: none;}
            .footer-container{padding: 25px 0 15px;text-align: center;}
            .phone-number span{font-size: 14px;}
            .contact-info address{margin-bottom: 5px;font-size: 14px;}
            .phone-number{padding-bottom: 0px;justify-content: center;}
            .contact-info a,.footer-menu ul li a{font-size: 14px;}
            .footer-menu{margin: 20px 0 0;}
            .copyright br{display: none;}
            .copyright{font-size: 13px;text-align: center;}
            .social-icons ul{justify-content: center;}
            .social-icons{padding-bottom: 20px;}
            .discover-more h2{text-align: center;}
            .single-grid{flex-direction: column;padding-bottom: 10px;margin-bottom: 20px; width: 100%;}
            .post-content{padding: 15px 0 0 0;}
            .post-list .featured-image{width: 100%;}
            .post-content h3{line-height: 26px;}
            .single-post img{float: left;width: 100%;padding: 0 0 20px 0;}
            .detect-mobile{display: block;}
            .search-content .btn-content .btn.btn-default{margin-left: 0;height: 40px;    padding: 5px 10px;}
            .content-footer span{font-size: 13px;margin: 0 0 10px 0;}
            .content-footer{flex-direction: column;margin: 20px 0 10px;}
            .single-post{margin: 30px 0 10px;}
            .detect-mobile{display: block;}
            .owl-carousel.owl-loaded {margin: 0;}
            /* .feature-single{padding-bottom: 30px;} */
            .features-section{padding-bottom: 35px;}
            .news-list .btn-responsive{margin: 30px auto 0;}
            .feed-single{padding-bottom: 20px;}
            .ad-content .btn.btn-default.btn-responsive{display: flex;justify-content: center;}
            .ad-single{margin-bottom: 25px;}
            .post-slider.owl-carousel .owl-item .col-sm-6{padding: 0;}
            .feature-slider.owl-carousel .owl-item .col-sm-12.col-md-6.col-lg-3.col-xl-3{padding: 0;}
            .news-slider.owl-carousel .owl-item .col-sm-6{padding: 0;}
            .discover-slider.owl-carousel .owl-item .col-sm-4{padding: 0;}
            .ad-slider.owl-carousel .owl-item .col-sm-12.col-md-6.col-lg-3.col-xl-3{padding: 0;}
            .logo{margin: 0 0 15px 0;text-align: center;}
            .header-right .menu-ul{border: 0;}
            .header-right .menu-li{padding: 6px 0 10px;}
            .header-right .menu-li:hover{border-bottom: none;}
            .header-right .menu-li.sign-in-li{border: 0;}
            .header-container{padding: 15px 0 0;}
            .innerpage-container .breadcrumb-blk{margin: 6px 0 10px;}
            .breadcrumb-blk ul li a{font-size: 13px;}
            .breadcrumb-blk ul li{padding: 0 10px 0 15px;}
            .header-right{width: 100%;padding: 0;}
            .logo img{width: 180px;}
            .more-list ul li{margin: 0 0 10px 0;}
            .more-list ul{padding: 0 15px;}
            .news-slider.owl-carousel .owl-item .col-sm-6,
            .post-slider.owl-carousel .owl-item .col-sm-6,
            .discover-slider.owl-carousel .owl-item .col-sm-4{max-width: 100%;}
            .feature-single img{width:inherit}
            .categories.owl-carousel .owl-item img {width: 100%;}
            .logo-block .btn.btn-default.btn-responsive:last-child{margin-right:10px;}
            .Second-articles-section .featured-image a,.featured-post .featured-image a{justify-content: center;display: flex;}
            .single-grid.summary-latest.second-article-section:nth-child(odd){padding-right:0px;}
            .single-grid.summary-latest.second-article-section:nth-child(even){padding-left:0px;}
            .subscribe-btn { margin-top: 25px; }
        }
        @media only screen and (max-width: 320px) {
            .header-right .menu-li{font-size: 11px;}
            .feature-single img{width:inherit}
            .categories.owl-carousel .owl-item img {width: inherit;}
        }
        @media(max-width: 767px){
          .search-content .btn-content {
            padding-left: 0;
            display: flex;
            justify-content: center;
          }
          .search-content .btn-content #pnlButtons{
            margin-left: 15px;
          }
        }
        .discover-slider .slick-slide{
          padding-left: 0px; 
          padding-right: 0px;
        }
    `}
    </style>

  )
}

export default NewsHomeStyles;